module.exports = __webpack_public_path__ + "img/icon_error.a9263aa0.svg";